import cx from 'classnames'
import { useMemo } from 'react'

import { type SanityBlogPostItemModule } from '@data/sanity/queries/types/modules'
import { backgroundColorClasses } from '@lib/color'
import {
  getDefaultBlogVerticalPaddingClasses,
  getSpacingClasses,
} from '@lib/spacing'

import BlogPostListItem from '@blocks/blog/blog-post-list-item'

type BlogPostItemProps = Pick<
  SanityBlogPostItemModule,
  'post' | 'options' | 'background' | 'spacing'
>

const BlogPostItem = ({
  post,
  options,
  background,
  spacing,
}: BlogPostItemProps) => {
  const sectionClasses = useMemo(
    () => [
      background ? backgroundColorClasses[background] : null,
      ...getDefaultBlogVerticalPaddingClasses(spacing?.padding),
      getSpacingClasses(spacing?.padding, 'right'),
      getSpacingClasses(spacing?.padding, 'left'),
    ],
    [background, spacing]
  )

  return (
    <section className={cx(sectionClasses)}>
      <div className="relative container">
        <div className="mx-auto">
          <BlogPostListItem
            post={post}
            options={options}
            verticalAlign="center"
          />
        </div>
      </div>
    </section>
  )
}

export default BlogPostItem
